// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import './helpers/Access-Statistics'
//import Swiper from "swiper"
import formurlencoded from 'form-urlencoded'
import _$ from './helpers/base.js'
import _vueBase from './helpers/vue/base.js'
import './assets/PageCommon/css/bootstrap.min.css'
import './assets/PageCommon/css/base.css'
import './assets/PageCommon/css/jquery.alerts.css'
import VueLazyload from 'vue-lazyload'
import 'font-awesome/css/font-awesome.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import './assets/PageCommon/font_icon/iconfont.css'
import '../static/icons/font_5038072_rgk08ws4ih/iconfont.css'
Vue.use(ElementUI);
Vue.use(VueLazyload, {
     loading: require('./assets/PageCommon/img/loading-img.gif'),//加载中图片，一定要有，不然会一直重复加载占位图
     error: require('./assets/PageCommon/img/404.png')  //加载失败图片
});
Vue.use(Vuex)
//组件库引用
import './assemblys/assemblys.js'
axios.defaults.withCredentials = true;
window.$={};
_$.extend('$', $, _$); //$扩展
_vueBase.extend(Vue, _vueBase); //vue扩展
Vue.config.productionTip = false
Vue.prototype.$axios = axios
//axios.defaults.baseURL = process.env.BASE_API; //"";
Vue.prototype.user=null;
Vue.prototype.domainUrlUtil={
  imageResources:'https://swkqp.oss-cn-chengdu.aliyuncs.com/',
  staticResources:'http://127.0.0.1/resources/front',
  // imageResources:'http://192.168.1.106:8080/ejsimage',
  // staticResources:'http://192.168.1.106:80/resources/front',
  urlResources:'https://swk-data.com',
  // urlResources:'https://t.swk-data.com',
  imageUrl: 'https://swk-data.com/api',
  // imageUrl: 'https://t.swk-data.com/api',
  // mobilelUrl: 'https://tm.swk-data.com',
  mobilelUrl: 'https://m.swk-data.com',
}
//全局变量
// var store = new Vuex.Store({
//   state: {
//     isUser:0,//是否有用户信息
//     isSowLogin:0,//是否显示登录框
//     funLogin:()=>{}//登录回调函数
//   }
// })

new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js